<app-resp-popup-title>
  <span i18n="@@AnlageAPI_FacilityLocationSelect_Title"
    >Select a Facility Location</span
  >
</app-resp-popup-title>
<app-resp-popup-content>
  <div style="width: 1400px; max-width: 80vw">
    <form [formGroup]="formFilter">
      <div class="row">
        <div class="col-11">
          <frm-text
            i18n-label="@@AnlageAPI_FacilityLocationSelect_SearchText"
            label="Search Text"
            formControlName="searchText"
			[hasReset]="true"
          ></frm-text>
        </div>
        <div class="col-1">
          <ctrl-btn icon="refresh" (click)="dataSource.refresh()"></ctrl-btn>
        </div>
      </div>
    </form>
    <div style="height: 900px; max-height: 65vh">
      <app-list-view
        [elevated]="false"
        [compact]="true"
        [columns]="columns"
        [dataSource]="dataSource"
		(rowClicked)="OnLocationSelect($event)"
    id="FacilityLocations"
      ></app-list-view>
    </div>
  </div>
</app-resp-popup-content>
